/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HeoCustomerNumber } from './HeoCustomerNumber';
import {
    HeoCustomerNumberFromJSON,
    HeoCustomerNumberFromJSONTyped,
    HeoCustomerNumberToJSON,
    HeoCustomerNumberToJSONTyped,
} from './HeoCustomerNumber';
import type { ClientCredentials } from './ClientCredentials';
import {
    ClientCredentialsFromJSON,
    ClientCredentialsFromJSONTyped,
    ClientCredentialsToJSON,
    ClientCredentialsToJSONTyped,
} from './ClientCredentials';

/**
 * 
 * @export
 * @interface SandboxClient
 */
export interface SandboxClient {
    /**
     * 
     * @type {HeoCustomerNumber}
     * @memberof SandboxClient
     */
    heoCustomerNumber: HeoCustomerNumber;
    /**
     * 
     * @type {ClientCredentials}
     * @memberof SandboxClient
     */
    clientCredentials: ClientCredentials;
    /**
     * 
     * @type {string}
     * @memberof SandboxClient
     */
    description: string;
    /**
     * 
     * @type {Date}
     * @memberof SandboxClient
     */
    createdAt: Date;
}

/**
 * Check if a given object implements the SandboxClient interface.
 */
export function instanceOfSandboxClient(value: object): value is SandboxClient {
    if (!('heoCustomerNumber' in value) || value['heoCustomerNumber'] === undefined) return false;
    if (!('clientCredentials' in value) || value['clientCredentials'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function SandboxClientFromJSON(json: any): SandboxClient {
    return SandboxClientFromJSONTyped(json, false);
}

export function SandboxClientFromJSONTyped(json: any, ignoreDiscriminator: boolean): SandboxClient {
    if (json == null) {
        return json;
    }
    return {
        
        'heoCustomerNumber': HeoCustomerNumberFromJSON(json['heoCustomerNumber']),
        'clientCredentials': ClientCredentialsFromJSON(json['clientCredentials']),
        'description': json['description'],
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function SandboxClientToJSON(json: any): SandboxClient {
    return SandboxClientToJSONTyped(json, false);
}

export function SandboxClientToJSONTyped(value?: SandboxClient | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'heoCustomerNumber': HeoCustomerNumberToJSON(value['heoCustomerNumber']),
        'clientCredentials': ClientCredentialsToJSON(value['clientCredentials']),
        'description': value['description'],
        'createdAt': value['createdAt'].toISOString(),
    };
}

